import TubCommon from "./tubCommon";

export default class JettedTub extends TubCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'jetted_tub';
    this.bottomTubId = "jetted_tub";
    this.visible = true;
    this.partName = 'Jetted Tub';
    this.translateId = "visualizer.bathroom.shower_tub_combo.jetted_tub";
    this.isStoneFeature = false;
    this.disableOnHomeSections = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new JettedTub());
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Shower.TubCombo.JettedTub;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndex;
    }
  }
}
